import { useParams } from 'react-router'
import { useState } from 'react'
import SurveySettings from './Components/SurveySettings'
import SurveyAnalytics from './Components/SurveyAnalytics'
import Tabs from 'src/Components/Tabs'
import BackBtn from 'src/Components/BackBtn'
import { useGetSurveyQuery } from 'src/redux/Api/surveysApi'
import SurveyPreview from './Components/SurveyPreview'

const Survey = () => {
  const { id } = useParams()
  const { data } = useGetSurveyQuery(+(id || 1))
  const [tabs, setTabs] = useState(0)
  if (!id) return <p>Survey not found</p>

  return (
    <>
      <h1>
        <BackBtn />
        Create Survey
      </h1>
      <section style={{ display: 'flex', gap: 24 }}>
        <div className="block" style={{ width: '100%' }}>
          <div>
            <Tabs name="set_stat" list={['Settings', 'Analytics']} onChange={setTabs} />
          </div>
          {data && tabs === 0 ? <SurveySettings surveyData={data} /> : <SurveyAnalytics id={id} />}
        </div>
        {data && tabs === 0 && <SurveyPreview survey={data} />}
      </section>
    </>
  )
}

export default Survey
